import { http, pagination, id } from 'utils'

import {
  SET_META,
  SET_INVOICE_RUNS,
  ADD_INVOICE_RUNS,
  SET_INVOICE_RUN,
  RESET_INVOICE_RUN
} from 'vx/mutations'

import { concat, findIndex } from 'lodash'
import xeroItemCodes from './invoice-runs/xero-item-codes'
import invoices from './invoice-runs/invoice-run-items'
import divisions from './invoice-runs/divisions'

export default {
  namespaced: true,

  modules: {
    xeroItemCodes,
    invoices,
    divisions
  },

  state: {
    invoiceRuns: [],
    invoiceRun: {},
    meta: null
  },

  actions: {
    async getInvoiceRuns ({ commit, state }, { params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta)) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      const response = await http.get('invoice-runs', { params })

      commit(ADD_INVOICE_RUNS, response.data.data)
      commit(SET_META, response.data.meta)

      return response
    },

    async getInvoiceRun ({ commit }, invoiceRun) {
      commit(RESET_INVOICE_RUN)
      const response = await http.get(`invoice-runs/${id(invoiceRun)}`)

      commit(SET_INVOICE_RUN, response.data.data)

      return response
    },

    async storeInvoiceRun ({ commit, state: { invoiceRuns, invoiceRun } }, payload) {
      const response = await http.post(`invoice-runs`, payload)

      commit(SET_INVOICE_RUN, response.data.data)

      invoiceRuns.unshift(response.data.data)

      commit(SET_INVOICE_RUNS, invoiceRuns)
      return response
    },

    async deleteInvoiceRun ({ commit }, { invoiceRunId }) {
      await http.delete(`invoice-runs/${id(invoiceRunId)}`)
      commit(SET_INVOICE_RUN, {})
    },

    async resetInvoiceRun ({ commit, state: { invoiceRuns, invoiceRun } }, { invoiceRunId }) {
      const response = await http.get(`invoice-runs/${id(invoiceRunId)}/reset`)

      commit(SET_INVOICE_RUN, response.data.data)

      let found = null
      if ((found = findIndex(invoiceRuns, u => u.id === invoiceRun.id))) {
        invoiceRuns.splice(found, 1, invoiceRun)
        commit(SET_INVOICE_RUNS, invoiceRuns)
      }

      return response
    },

    async finaliseInvoiceRun ({ commit, state: { invoiceRuns, invoiceRun } }, { invoiceRunId, payload }) {
      const response = await http.post(`invoice-runs/${id(invoiceRunId)}/finalise`, payload)

      commit(SET_INVOICE_RUN, response.data.data)

      let found = null
      if ((found = findIndex(invoiceRuns, u => u.id === invoiceRun.id))) {
        invoiceRuns.splice(found, 1, invoiceRun)
        commit(SET_INVOICE_RUNS, invoiceRuns)
      }

      return response
    },

    async generateXeroInvoices ({ commit, state: { invoiceRuns, invoiceRun } }, { invoiceRunId, payload }) {
      const response = await http.get(`invoice-runs/${id(invoiceRunId)}/generate-xero-invoices`, payload)
      return response
    },

    resetInvoiceRuns ({ commit }) {
      commit(SET_INVOICE_RUNS, [])
      commit(SET_META, null)
    },
    resetSingleInvoiceRun ({ commit }) {
      commit(SET_INVOICE_RUN, {})
    }
  },

  mutations: {
    [SET_INVOICE_RUNS] (state, invoiceRuns) {
      state.invoiceRuns = invoiceRuns
    },

    [ADD_INVOICE_RUNS] (state, invoiceRuns) {
      state.invoiceRuns = concat(state.invoiceRuns, invoiceRuns)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    },

    [RESET_INVOICE_RUN] (state, invoiceRun) {
      state.invoiceRun = {}
    },

    [SET_INVOICE_RUN] (state, invoiceRun) {
      state.invoiceRun = invoiceRun
    }
  }
}
